<script setup lang="ts">
import { faxPrices } from '~/data/prices/fax';

const props = defineProps<{
    title: string,
    desc: string,
}>();
</script>

<template>
    <SectionsPricesBase :title="props.title" :desc="props.desc">
        <div class="w-full flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-8 mt-10 lg:mt-15">
            <LazyCardsPricing
                v-for="item in faxPrices"
                :key="item.title"
                :item="item"
            />
        </div>
    </SectionsPricesBase>
</template>